import Vue from 'vue'
import Router from 'vue-router'

import {
	constantRouterMap
} from '@router/router.config.js'
Vue.use(Router)
import myWxConfig from '@utils/myWxConfig';

const router = new Router({
	mode: 'history', // 如果你是 history模式 需要配置vue.config.js publicPath
	base: process.env.BASE_URL,
	scrollBehavior(to, from, savedPosition) {
		// keep-alive 返回缓存页面后记录浏览位置
		if (savedPosition && to.meta.keepAlive) {
			return savedPosition;
		}
		// 异步滚动操作
		return new Promise((resolve) => {
			setTimeout(() => {
				resolve({
					x: 0,
					y: 1
				});
			}, 0);
		});
	},
	routes: constantRouterMap
})
router.beforeEach((to, from, next) => {
	//页面中是否隐藏微信分享、复制链接等功能，如果所有页面都隐藏，在APP.vue页面引入并myWxConfig调用即可
	if (!to.meta.isShowWxOptionMenu) {
		myWxConfig.wxHideOptionMenu();
	}
	//动态切换页面标题
	const title = to.meta && to.meta.title;
	if (title) {
		document.title = title;
	}
	next();

});

//const whiteList = ['/login', '/switch']
/* router.beforeEach((to, from, next) => {
  if (whiteList.indexOf(to.path) !== -1) {
    next()
  } else {
    let token = db.get('USER_TOKEN')
    if (token.length) {
      next()
    } else {
      next("/login")
    }
  }
}) */
export default router
